import { defineAsyncComponent } from 'vue'
import type { RouteRecordRaw } from 'vue-router'

const pageRoutes: RouteRecordRaw[] = [
    {
        name: 'login',
        path: '/:lang/accounts/login/',
        component: () => import('./LoginPage.vue'),
        children: [
          {
            name: 'bankid',
            path: 'bankid/',
            component: () => import('layout_congress/vue/formsV2/DjangoFormModalWrapper.vue'),
            meta: {
              'defaultModalClass': null,
              'components': {
                BankIDJsonWidget: defineAsyncComponent(() => import('bank_id/vue/BankIDJsonWidget.vue')),
              },
              form: true,
            },
          }
        ]
    },
    {
        name: 'admin-login',
        path: '/:lang/admin/login/',
        component: () => import('./LoginPage.vue'),
        children: [
          {
            name: 'admin-bankid',
            path: 'bankid/',
            component: () => import('layout_congress/vue/formsV2/DjangoFormModalWrapper.vue'),
            meta: {
              'defaultModalClass': null,
              'components': {
                BankIDJsonWidget: defineAsyncComponent(() => import('bank_id/vue/BankIDJsonWidget.vue')),
              },
              form: true,
            },
          }
        ]
    },
]

export const routes = pageRoutes

export default routes
